import useRipple from "use-ripple-hook/ripple";
import { Link } from "react-router-dom";

function SubSection(props: Props) {
  const [ripple, event] = useRipple();

  return (
    <Link to={props.path} className={'sub-section'} ref={ripple} onMouseDown={event}>
      <img src={props.image} alt={props.name} />
      <span>{props.name}</span>
    </Link>
  )
}

export default SubSection;

class Props {
  name: string;
  image: string;
  path: string;
}
